<template>
    <div class="container">
        <form id="roleForm" @submit.prevent="addRole">
            <div class="tab-content-inner">
                <div class="people-management-inner-content p-5">
                    <div class="user-permissions">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <template v-if="permissions != null">
                        
                            <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                <div class="permissions-box">
                                    <div class="row">
                                        <div class="col-md-4 mb-2" v-for="child in permission">
                                            <label class="check-holder ml-0">
                                                <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                </div>

                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/listRolesAdmin" class="btn btn-primary float-right mr-1"> Cancel </router-link>
            </div>
            </div>
            
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                role : {},
                permissions : null,
                category : null,
                form: new Form({
                    name : '',
                    rolePermissions : []
                }),
            }
        },
        methods: {
            addRole() {
                this.$Progress.start();
                this.form.post('api/addAdminRole')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Role created successfully'
                        });
                        this.$router.push('/listRolesAdmin');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
        },
        updated(){
        },
        created() {
            axios.get('api/getAllPermissions').then(res => {
                if(res.status == 200){
                    this.permissions = res.data;
                }else{
                    this.showAlertBox('error','Add Role','Some error has been occurred');
                }
            }).catch(err => {
                console.log(err);
                this.showAlertBox('error','Add Role','Some Problem occurred please try again later');
            });
        },
    }
</script>
